<div class="settings-log p-24">
  <div class="mat-subtitle-2 fw-600 fs-18 mt-8 mb-10">
    {{ 'INSTANCE_DETAILS.LOG_LEVEL_CONFIG' | transloco }}
  </div>

  <div class="mat-subtitle-2 fw-700 fs-12 mt-8 mb-10">
    {{ 'INSTANCE_DETAILS.TYPE' | transloco | uppercase }}
  </div>

  <div class="flex flex-row self-start mt-12">
    @for (option of type; track option) {
      <!-- <div (click)="!option.disabled && selectOptionsType(option)"> -->
        <div [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || isInprogress) : isInprogress}" (click)="selectOptionsType(option)">
        <div class="flex flex-row mr-20" >
          <mat-icon [svgIcon]="option.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-0"></mat-icon>
          <span class="mt-4 ml-10">{{ option.label | titlecase }}</span>
        </div>
      </div>
    }
  </div>

  <!-- @for (option of type; track option) {
    @if (option.selected) {
      <div class="flex flex-row">
        <span class="message-color fw-400 fs-14 mt-26">{{ option.message }}</span>
      </div>
    }
  } -->
</div>
